import { render, staticRenderFns } from "./ReceiptComponent.vue?vue&type=template&id=357a3af0&scoped=true"
import script from "./ReceiptComponent.vue?vue&type=script&lang=js"
export * from "./ReceiptComponent.vue?vue&type=script&lang=js"
import style0 from "./ReceiptComponent.vue?vue&type=style&index=0&id=357a3af0&prod&scoped=true&lang=css"
import style1 from "./ReceiptComponent.vue?vue&type=style&index=1&id=357a3af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357a3af0",
  null
  
)

export default component.exports